// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"b3cb003f","808":"b3cb003f"}[chunkId] + ".chunk.css";
};